import { MsgExecuteContract, MsgSend } from '@goblinhunt/cosmes/client';

import SecureAPIClient from './api-connect.js';

const API = new SecureAPIClient();



export async function mintNFT(nftData, wallet) {

  try {

    if (!wallet || !wallet.address) {

      throw new Error('Wallet is not connected properly.');

    }

    const sender = wallet.address;
    const feeAddress = "terra12v5pxjv76hydvlj46kccqe362cky5rps92kqgg";
    const priceInLunc = parseFloat(nftData.price || '0');
    const totalAmountUluna = Math.floor(priceInLunc * 1_000_000); // full price in uluna
    const feeInUluna = Math.floor(totalAmountUluna * 0.025); // 5% fee
    const paymentAmountUluna = totalAmountUluna - feeInUluna;
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const customTimestamp = `${hours}${minutes}${day}${month}${year}`;
    const randomStr = Math.random().toString(36).substring(2, 7).toUpperCase();

    nftData.tokenid = `${nftData.name}_${customTimestamp}_${randomStr}`;
    
const tx = {
  msgs: [
    new MsgSend({
      fromAddress: sender,
      toAddress: feeAddress,
      amount: [
        {
          denom: 'uluna',
          amount: feeInUluna.toString(),
        },
      ],
    }),
    new MsgSend({
      fromAddress: sender,
      toAddress: nftData.owner,
      amount: [
        {
          denom: 'uluna',
          amount: paymentAmountUluna.toString(),
        },
      ],
    }),
  ],
  memo: 'NFT Minted Via NFT.Lunc.Tools',
};

// Estimate fee
const fee = await wallet.estimateFee(tx, 2.0);
const account = await wallet.client?.getAccount(wallet.address);// Broadcast transaction
const txHash = await wallet.broadcastTx(tx, fee);

    const confirmed = await waitForTxSuccess(txHash);

    if (!confirmed) throw new Error('Transaction was not confirmed after waiting');


    
    console.log('UpdateMintCount: ' + nftData.id)
    await fetch('/update-mint-count', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        nft_id: nftData.id
      })

    });

    

    let requestData = {
        token_id: nftData.tokenid, 
        recipient:sender, 
        token_uri: nftData.image, 
        name: nftData.name,
        descript: nftData.description,
        image: nftData.image,
        royalty_percentage: nftData.royalty_percentage, 
        royalty_payment_address: nftData.royalty_address, 
        contract: nftData.contract_address
    };

    let response2 = await API.makeSecureRequest('/faucet-tx', requestData);
    const newTxHash = response2.hash;
    return newTxHash;

  } catch (err) {
    console.error('🔥 Error during mint:', err?.response?.data || err.message || err);
    throw err;
  }

}




async function waitForTxSuccess(txHash, maxTries = 10, delayMs = 1500) {
  const checkUrl = `https://terra-classic-lcd.publicnode.com/cosmos/tx/v1beta1/txs/${txHash}`;

  for (let i = 0; i < maxTries; i++) {
    try {
      const res = await fetch(checkUrl);
      if (res.status === 200) {
        const json = await res.json();
        if (json.tx_response?.code === 0) {
          console.log('✅ Tx confirmed');
          return true;
        } else {
          console.error('❌ Tx failed on chain:', json.tx_response);
          return false;
        }
      }
    } catch (e) {
      console.warn('⏳ Tx not found yet, retrying...');
    }
    await new Promise(resolve => setTimeout(resolve, delayMs));
  }

  console.error('❌ Tx confirmation timed out');

  return false;

}

